/**
 * King — cadeau-assistent van bedrukking.nl
 *
 * Zelfstandig, geen theme-afhankelijkheden. Het theme (Savor/Horizon) heeft wel
 * een eigen dialoogcomponent, maar die is modaal: hij vergrendelt de pagina en
 * sluit bij een klik ernaast. Voor een chat waarin je juist wilt blijven
 * doorlezen is dat verkeerd, en het zou ons vastknopen aan een ongedocumenteerde
 * interne API van een theme dat door Shopify wordt bijgewerkt.
 *
 * Configuratie komt uit window.BK_KING (gezet in snippets/king-chat.liquid).
 */
(function () {
  var cfg = window.BK_KING;
  if (!cfg || !cfg.endpoint) return;

  var wortel = document.querySelector('.bkk');
  if (!wortel || wortel.dataset.bkkKlaar) return;
  wortel.dataset.bkkKlaar = '1';

  var POSES = ['idle', 'wave', 'thinking', 'search', 'gift', 'success', 'error'];

  // De zwaai zit sinds deze ronde volledig in CSS: één vast lichaam met de arm
  // als losse laag die om de schouder draait. Er valt hier dus niets meer te
  // wisselen — wat de oorzaak van het schokken wegneemt, want elk beeldje was
  // een aparte render met de kroon een paar pixels verderop.
  var MAX_BEURTEN = 12;
  var MAX_TEKENS = 1000;
  var POSE_RUST_MS = 400;
  var OPSLAG = 'bkk-gesprek';
  var TIP_GEZIEN = 'bkk-tip-gezien';

  var knop = wortel.querySelector('.bkk-knop');
  var rustigerAan = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var levenTimers = [];
  var paneel = null;
  var el = {};

  var historie = [];        // [{rol, tekst}]
  var gesprekId = null;
  var bezig = false;
  var afbreker = null;
  var poseTimer = null;
  var huidigePose = 'wave';

  /* ---------------------------------------------------------------- helpers */

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'c-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  function veiligOpslaan(sleutel, waarde) {
    try { sessionStorage.setItem(sleutel, waarde); } catch (e) { /* privémodus */ }
  }
  function veiligLezen(sleutel) {
    try { return sessionStorage.getItem(sleutel); } catch (e) { return null; }
  }

  /**
   * Modeltekst naar DOM. Bewust géén innerHTML: die tekst komt uit een taalmodel
   * dat door de bezoeker gestuurd wordt, dus alles wat op HTML lijkt hoort tekst
   * te blijven. Alleen **vet** en regeleindes worden opgemaakt.
   */
  function schrijfTekst(doel, tekst) {
    doel.textContent = '';
    var delen = String(tekst).split(/(\*\*[^*]+\*\*)/g);
    delen.forEach(function (deel) {
      if (/^\*\*[^*]+\*\*$/.test(deel)) {
        var sterk = document.createElement('strong');
        sterk.textContent = deel.slice(2, -2);
        doel.appendChild(sterk);
      } else if (deel) {
        doel.appendChild(document.createTextNode(deel));
      }
    });
  }

  /* ------------------------------------------------------------------ leven */

  /**
   * King laten leven met echte tweede filmbeeldjes.
   *
   * Het ademen zit in CSS. Wat hier gebeurt is het wisselen van beeldje: een
   * knipper (idle → idle-blink → idle) en een zwaai (wave → wave-2 → wave).
   * Allebei zijn het aparte renders uit hetzelfde Kive-karaktermodel, met
   * dezelfde kadrering, zodat de wissel geen sprongetje geeft.
   *
   * Bewust met setTimeout en niet met een CSS-animatie op meerdere lagen: de
   * knipper moet ONREGELMATIG zijn. Een blik die elke exact vier seconden
   * knippert valt op als een machine; een beetje toeval leest als een mens.
   */
  function stopLeven() {
    levenTimers.forEach(clearTimeout);
    levenTimers = [];
  }

  /**
   * Eén pose zichtbaar maken. Let op de directe-kind-selector: de zwaaipose is
   * geen losse afbeelding maar een rig met twee afbeeldingen erin, en die
   * binnenste twee moeten niet als losse poses behandeld worden.
   */
  function toonBeeldje(container, pose) {
    if (!container) return;
    var doel = container.querySelector(':scope > [data-pose="' + pose + '"]');
    if (!doel || doel.hasAttribute('data-actief')) return;
    container.querySelectorAll(':scope > [data-actief]').forEach(function (el2) {
      el2.removeAttribute('data-actief');
    });
    doel.setAttribute('data-actief', '');
  }

  function wisselBeeldje(container, van, naar, duurMs) {
    if (!container) return;
    var a = container.querySelector(':scope > [data-pose="' + van + '"]');
    var b = container.querySelector(':scope > [data-pose="' + naar + '"]');
    if (!a || !b) return;
    a.removeAttribute('data-actief');
    b.setAttribute('data-actief', '');
    levenTimers.push(setTimeout(function () {
      // Alleen terugzetten als de pose intussen niet veranderd is.
      if (huidigePose !== van) return;
      b.removeAttribute('data-actief');
      a.setAttribute('data-actief', '');
    }, duurMs));
  }

  function planLeven() {
    stopLeven();
    if (rustigerAan) return;

    function knipper() {
      var wacht = 2600 + Math.random() * 4200;
      levenTimers.push(setTimeout(function () {
        if (huidigePose === 'idle') {
          wisselBeeldje(el.avatar, 'idle', 'idle-blink', 130);
          // Af en toe twee keer kort achter elkaar; dat doen mensen ook.
          if (Math.random() < 0.25) {
            levenTimers.push(setTimeout(function () {
              if (huidigePose === 'idle') wisselBeeldje(el.avatar, 'idle', 'idle-blink', 120);
            }, 340));
          }
        }
        knipper();
      }, wacht));
    }



    knipper();
  }

  /* ------------------------------------------------------------------ poses */

  function zetPose(pose, meteen) {
    if (POSES.indexOf(pose) === -1) pose = 'idle';
    clearTimeout(poseTimer);
    // Zonder deze rustpauze flitst King bij een snel antwoord binnen één seconde
    // door thinking, search, gift en success heen. Dat oogt kapot.
    var doen = function () {
      var veranderd = huidigePose !== pose;
      huidigePose = pose;
      if (!el.avatar) return;
      toonBeeldje(el.avatar, pose);
      if (veranderd && !rustigerAan) {
        var laag = el.avatar.parentElement;
        if (laag && laag.classList.contains('bkk-avatar__leven')) {
          laag.classList.remove('is-gewisseld');
          void laag.offsetWidth;            // herstart de animatie
          laag.classList.add('is-gewisseld');
          // Met animationend en niet met een timer: een timer in levenTimers
          // wordt door de eerstvolgende planLeven() gewist, en dan blijft de
          // class hangen en komt het ademen nooit meer terug.
          laag.addEventListener('animationend', function weg() {
            laag.classList.remove('is-gewisseld');
            laag.removeEventListener('animationend', weg);
          });
        }
      }
      planLeven();
    };
    if (meteen || pose === 'error') doen();
    else poseTimer = setTimeout(doen, POSE_RUST_MS);
  }

  function zetStatus(tekst) {
    if (el.status) el.status.textContent = tekst;
  }

  /* ----------------------------------------------------------------- paneel */

  function bouwPaneel() {
    var sjabloon = document.getElementById('bkk-paneel-sjabloon');
    if (!sjabloon) return null;
    wortel.appendChild(sjabloon.content.cloneNode(true));
    paneel = wortel.querySelector('.bkk-paneel');

    el.avatar = paneel.querySelector('.bkk-avatar');
    el.status = paneel.querySelector('[data-rol="status"]');
    el.log = paneel.querySelector('.bkk-log');
    el.sr = paneel.querySelector('.bkk-sr');
    el.chips = paneel.querySelector('.bkk-chips');
    el.form = paneel.querySelector('.bkk-form');
    el.invoer = paneel.querySelector('.bkk-invoer');
    el.stuur = paneel.querySelector('.bkk-stuur');
    el.sluit = paneel.querySelector('.bkk-sluit');

    el.form.addEventListener('submit', function (e) { e.preventDefault(); verstuur(el.invoer.value); });
    el.sluit.addEventListener('click', sluitPaneel);
    el.invoer.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); verstuur(el.invoer.value); }
    });
    el.invoer.addEventListener('input', function () {
      el.invoer.style.height = 'auto';
      el.invoer.style.height = Math.min(el.invoer.scrollHeight, 120) + 'px';
    });
    el.chips.addEventListener('click', function (e) {
      var chip = e.target.closest('.bkk-chip');
      if (chip) verstuur(chip.textContent);
    });
    paneel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !isMobiel()) return;
      vangFocus(e);
    });

    // Zie volgToetsenbord(): zonder dit schuift het paneel weg zodra het
    // toetsenbord opkomt.
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', volgToetsenbord);
      window.visualViewport.addEventListener('scroll', volgToetsenbord);
    }
    // Na het opkomen van het toetsenbord staat de laatste regel vaak net buiten
    // beeld; even naar beneden scrollen zodra alles gezet is.
    el.invoer.addEventListener('focus', function () {
      setTimeout(function () { volgToetsenbord(); scrollNaarBeneden(); }, 300);
    });
    return paneel;
  }

  function vangFocus(e) {
    var focusbaar = paneel.querySelectorAll('button, [href], textarea, input, [tabindex]:not([tabindex="-1"])');
    if (!focusbaar.length) return;
    var eerste = focusbaar[0];
    var laatste = focusbaar[focusbaar.length - 1];
    if (e.shiftKey && document.activeElement === eerste) { e.preventDefault(); laatste.focus(); }
    else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
  }

  function isMobiel() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  /**
   * Het paneel op het zichtbare deel van het scherm houden.
   *
   * Zodra het toetsenbord opkomt krimpt de *visuele* viewport, maar de layout
   * viewport blijft even groot. Een element met position:fixed hangt aan die
   * layout viewport, dus het schuift onder het toetsenbord door — en iOS
   * scrollt daar bovenop de pagina om het invoerveld in beeld te brengen,
   * waardoor het hele venster omhoog springt. Dat was precies de klacht.
   *
   * De oplossing is het paneel expliciet uitlijnen op visualViewport: hoogte
   * gelijk aan het zichtbare deel, en de bovenkant op offsetTop. Beide events
   * zijn nodig: resize vuurt bij het openen van het toetsenbord, scroll bij het
   * meeschuiven van de visuele viewport.
   */
  function volgToetsenbord() {
    if (!paneel || paneel.hidden || !window.visualViewport) return;
    if (!isMobiel()) {
      paneel.style.height = '';
      paneel.style.top = '';
      return;
    }
    var vv = window.visualViewport;
    paneel.style.height = vv.height + 'px';
    paneel.style.top = vv.offsetTop + 'px';
  }

  /* Bijhouden of iemand met het toetsenbord of met de vinger werkt. Alleen in
     het eerste geval krijgt de knop na sluiten zijn focus terug. */
  var viaToetsenbord = false;
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' || e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') viaToetsenbord = true;
  }, true);
  document.addEventListener('pointerdown', function () { viaToetsenbord = false; }, true);

  function openPaneel() {
    verbergTip(true);
    if (!paneel && !bouwPaneel()) return;
    paneel.hidden = false;
    knop.setAttribute('aria-expanded', 'true');
    knop.hidden = true;

    if (isMobiel()) {
      paneel.setAttribute('aria-modal', 'true');
      vergrendelPagina();
      volgToetsenbord();
      // Op mobiel eerst naar de sluitknop: focus op het invoerveld klapt meteen
      // het toetsenbord open en dan zie je het welkomstscherm niet.
      el.sluit.focus();
    } else {
      paneel.setAttribute('aria-modal', 'false');
      el.invoer.focus();
    }

    // Er kan geschiedenis in sessionStorage staan zonder dat we automatisch
    // heropenden (de bezoeker klikte geen productkaart, maar het gesprek liep
    // wel). Die alsnog tekenen, anders opent King met een leeg venster terwijl
    // hij het gesprek nog gewoon kent.
    if (!el.log.children.length) {
      if (historie.length) tekenHistorie();
      else toonWelkom();
    }
    zetPose(historie.length ? 'idle' : 'wave', true);
  }

  function sluitPaneel() {
    if (afbreker) { afbreker.abort(); afbreker = null; }
    stopLeven();
    if (paneel) { paneel.hidden = true; paneel.style.height = ''; paneel.style.top = ''; }
    ontgrendelPagina();
    knop.hidden = false;
    knop.setAttribute('aria-expanded', 'false');
    // Focus alleen teruggeven aan wie met het toetsenbord werkt. Programmatische
    // focus telt in Safari namelijk óók als :focus-visible, dus na sluiten met de
    // vinger bleef er een blauw kader om King staan tot je ergens anders tikte.
    if (viaToetsenbord) knop.focus();
    bewaar();
  }

  /**
   * De pagina eronder stilzetten terwijl het paneel openstaat.
   *
   * `overflow: hidden` op html is op iOS niet genoeg: de pagina scrollt daar
   * alsnog zodra een invoerveld focus krijgt. De body op position:fixed zetten
   * met een negatieve top is het recept dat wél werkt — hetzelfde dat het theme
   * zelf in dialog.js gebruikt. De scrollpositie wordt bewaard en bij sluiten
   * exact teruggezet, anders staat de bezoeker ineens bovenaan de pagina.
   */
  var bewaardeScroll = 0;

  function vergrendelPagina() {
    bewaardeScroll = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('bkk-slot');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + bewaardeScroll + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function ontgrendelPagina() {
    if (!document.documentElement.classList.contains('bkk-slot')) return;
    document.documentElement.classList.remove('bkk-slot');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, bewaardeScroll);
  }

  function verbergTip(voorgoed) {
    var tip = wortel.querySelector('.bkk-tip');
    if (tip) tip.remove();
    if (voorgoed) { try { localStorage.setItem(TIP_GEZIEN, '1'); } catch (e) {} }
  }

  /* ------------------------------------------------------------- berichten */

  function scrollNaarBeneden(alleenAlsOnderaan) {
    if (!el.log) return;
    var onderaan = el.log.scrollHeight - el.log.scrollTop - el.log.clientHeight < 60;
    if (alleenAlsOnderaan && !onderaan) return;
    el.log.scrollTop = el.log.scrollHeight;
  }

  /**
   * De zwaaiende King als twee lagen. Er bestaat geen losse afbeelding meer van
   * die pose — het lichaam en de arm zijn aparte bestanden, zodat alleen de arm
   * beweegt.
   */
  function maakRig(maat) {
    var rig = document.createElement('span');
    rig.className = 'bkk-rig';
    rig.style.width = maat + 'px';
    rig.style.height = maat + 'px';
    // Arm eerst: die hoort achter het lichaam te liggen.
    ['arm', 'lichaam'].forEach(function (laag) {
      var img = document.createElement('img');
      img.className = 'bkk-rig__' + laag;
      img.src = cfg.lagen[laag];
      img.alt = '';
      img.width = maat;
      img.height = maat;
      img.decoding = 'async';
      rig.appendChild(img);
    });
    return rig;
  }

  function toonWelkom() {
    var wrap = document.createElement('div');
    wrap.className = 'bkk-welkom';
    wrap.appendChild(maakRig(150));
    var p = document.createElement('p');
    p.textContent = 'Hoi! Ik ben King. Voor wie zoek je een cadeau?';
    wrap.appendChild(p);
    el.log.appendChild(wrap);
    toonChips(cfg.suggesties || []);
  }

  function tekenHistorie() {
    historie.forEach(function (b) {
      voegBericht(b.rol === 'king' ? 'king' : 'klant', b.tekst);
      if (b.rol !== 'king') return;
      toonKaarten(b.producten);
      toonActies(b.acties);
    });
  }

  function toonChips(lijst) {
    el.chips.textContent = '';
    (lijst || []).forEach(function (tekst) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bkk-chip';
      b.textContent = tekst;
      el.chips.appendChild(b);
    });
  }

  function voegBericht(rol, tekst) {
    var d = document.createElement('div');
    d.className = 'bkk-bericht bkk-bericht--' + rol;
    if (tekst) schrijfTekst(d, tekst);
    el.log.appendChild(d);
    scrollNaarBeneden();
    return d;
  }

  function toonTypt() {
    var d = document.createElement('div');
    d.className = 'bkk-bericht bkk-bericht--king';
    var t = document.createElement('span');
    t.className = 'bkk-typt';
    t.innerHTML = '<span></span><span></span><span></span>';
    d.appendChild(t);
    el.log.appendChild(d);
    scrollNaarBeneden();
    return d;
  }

  function toonKaarten(items) {
    if (!items || !items.length) return;
    var lijst = document.createElement('ul');
    lijst.className = 'bkk-kaarten';
    items.forEach(function (p) {
      var item = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'bkk-kaart';
      // Bewust een echte ul/li met een gewone link erin. Eerst stond er
      // role="listitem" op de <a> zelf, en dat overschrijft de linkrol: een
      // schermlezer meldde het dan niet meer als link.
      a.href = p.url;
      a.addEventListener('click', function () {
        // Het gesprek bewaren, maar het paneel NIET laten heropenen op de
        // productpagina. Dat deed het eerst wel, en dan landde je op het
        // artikel met de chat er bovenop — het leek alsof er niets gebeurde.
        // Wie verder wil praten klikt de knop weer aan en vindt het gesprek
        // terug.
        bewaar();
        if (paneel && !paneel.hidden) sluitPaneel();
      });

      if (p.foto) {
        var img = document.createElement('img');
        img.className = 'bkk-kaart__foto';
        // Shopify schaalt zelf; de originele bestanden zijn 2000 px breed.
        img.src = p.foto + (p.foto.indexOf('?') === -1 ? '?' : '&') + 'width=240';
        img.alt = ''; img.width = 116; img.height = 116;
        img.loading = 'lazy'; img.decoding = 'async';
        a.appendChild(img);
      }
      var t = document.createElement('span');
      t.className = 'bkk-kaart__titel'; t.textContent = p.titel;
      var pr = document.createElement('span');
      pr.className = 'bkk-kaart__prijs'; pr.textContent = p.prijs;
      a.appendChild(t); a.appendChild(pr);
      item.appendChild(a);
      lijst.appendChild(item);
    });
    el.log.appendChild(lijst);
    scrollNaarBeneden();
  }

  /**
   * Knoppen onder een antwoord, nu alleen WhatsApp. King zegt zelf nooit een
   * telefoonnummer of link — dat komt hiervandaan, zodat er nooit een cijfer
   * in kan omvallen.
   */
  function toonActies(items) {
    if (!items || !items.length) return;
    var rij = document.createElement('div');
    rij.className = 'bkk-acties';
    items.forEach(function (a) {
      var link = document.createElement('a');
      link.className = 'bkk-actie bkk-actie--' + (a.soort || 'link');
      link.href = a.url;
      link.target = '_blank';
      link.rel = 'noopener';
      if (a.soort === 'whatsapp') {
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('width', '18');
        svg.setAttribute('height', '18');
        svg.setAttribute('aria-hidden', 'true');
        var pad = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        pad.setAttribute('fill', 'currentColor');
        pad.setAttribute('d', 'M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.96L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 18.15h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.23 8.25-8.23a8.2 8.2 0 0 1 8.24 8.24c0 4.54-3.7 8.23-8.24 8.23Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.78.97-.15.16-.29.18-.53.06-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.5.11-.11.25-.29.37-.44.13-.15.17-.25.25-.41.08-.17.04-.31-.02-.44-.06-.12-.56-1.35-.76-1.84-.2-.48-.4-.42-.56-.43h-.48c-.16 0-.43.06-.65.31-.23.25-.86.84-.86 2.04s.88 2.37 1 2.53c.13.17 1.74 2.65 4.2 3.72.59.25 1.05.4 1.4.52.59.18 1.13.16 1.55.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.1-.22-.17-.47-.29Z');
        svg.appendChild(pad);
        link.appendChild(svg);
      }
      var tekst = document.createElement('span');
      tekst.className = 'bkk-actie__tekst';
      var label = document.createElement('strong');
      label.textContent = a.label;
      tekst.appendChild(label);
      if (a.toelichting) {
        var sub = document.createElement('span');
        sub.className = 'bkk-actie__sub';
        sub.textContent = a.toelichting;
        tekst.appendChild(sub);
      }
      link.appendChild(tekst);
      rij.appendChild(link);
    });
    el.log.appendChild(rij);
    scrollNaarBeneden();
  }

  function toonFout(tekst) {
    var d = document.createElement('div');
    d.className = 'bkk-fout';
    d.textContent = tekst;
    el.log.appendChild(d);
    scrollNaarBeneden();
    zetPose('error', true);
    zetStatus('Er ging iets mis');
  }

  /* --------------------------------------------------------------- verzenden */

  function verstuur(ruw) {
    var tekst = String(ruw || '').trim();
    if (!tekst || bezig) return;
    if (tekst.length > MAX_TEKENS) tekst = tekst.slice(0, MAX_TEKENS);

    if (historie.filter(function (b) { return b.rol === 'gebruiker'; }).length >= 30) {
      toonFout('Dit gesprek is lang geworden. Ververs de pagina om opnieuw te beginnen.');
      return;
    }

    var welkom = el.log.querySelector('.bkk-welkom');
    if (welkom) welkom.remove();

    el.invoer.value = '';
    el.invoer.style.height = 'auto';
    toonChips([]);
    voegBericht('klant', tekst);
    historie.push({ rol: 'gebruiker', tekst: tekst });

    praat();
  }

  function praat() {
    bezig = true;
    el.stuur.disabled = true;
    zetStatus('King denkt na…');
    zetPose('thinking', true);

    var typt = toonTypt();
    var bubbel = null;
    var antwoord = '';
    var zoekTimer = setTimeout(function () {
      if (!antwoord) { zetPose('search', true); zetStatus('King zoekt in de collectie…'); }
    }, 1500);

    afbreker = new AbortController();
    gesprekId = gesprekId || uuid();

    fetch(cfg.endpoint, {
      method: 'POST',
      credentials: 'omit',
      signal: afbreker.signal,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        widget_token: cfg.token,
        gesprek_id: gesprekId,
        // Alleen rol en tekst de deur uit: de kaartjes bewaren we lokaal om ze
        // te kunnen terugtekenen, maar de server maakt ze zelf opnieuw.
        berichten: historie.slice(-MAX_BEURTEN).map(function (b) {
          return { rol: b.rol, tekst: b.tekst };
        }),
        pagina: { template: cfg.template, pad: location.pathname },
      }),
    })
      .then(function (r) {
        clearTimeout(zoekTimer);
        var type = r.headers.get('content-type') || '';
        if (type.indexOf('text/event-stream') !== -1) return leesStroom(r, aanTekst, aanKlaar, aanFout);
        return r.json().then(function (data) {
          if (!r.ok || data.ok === false) return aanFout((data.fouten || [])[0]);
          aanTekst(data.tekst);
          aanKlaar(data);
        });
      })
      .catch(function (fout) {
        clearTimeout(zoekTimer);
        if (fout.name === 'AbortError') return;
        aanFout('King is even niet bereikbaar. Probeer het zo nog eens.');
      });

    function aanTekst(stukje) {
      if (!stukje) return;
      if (!bubbel) { typt.remove(); bubbel = voegBericht('king', ''); zetStatus('King typt…'); }
      antwoord += stukje;
      schrijfTekst(bubbel, antwoord);
      scrollNaarBeneden(true);
    }

    function aanKlaar(data) {
      if (typt.parentNode) typt.remove();
      if (!bubbel && data.tekst) { bubbel = voegBericht('king', ''); antwoord = data.tekst; schrijfTekst(bubbel, antwoord); }
      // De kaartjes en knoppen horen bij dit antwoord en gaan mee de historie
      // in. Anders is na een klik op een product en terugkomen in de chat alleen
      // de tekst er nog, en moet de bezoeker opnieuw vragen wat King net al
      // liet zien.
      historie.push({
        rol: 'king',
        tekst: antwoord,
        producten: data.producten || [],
        acties: data.acties || [],
      });
      toonKaarten(data.producten);
      toonActies(data.acties);
      zetPose(data.pose || (data.producten && data.producten.length ? 'gift' : 'success'));
      zetStatus('Beschikbaar');
      // Het volledige antwoord in één keer in de leefregio; per stukje zou een
      // schermlezer elk los woord voorlezen.
      if (el.sr) {
        var kaartTekst = (data.producten || []).length
          ? ' ' + data.producten.length + ' productsuggesties: ' + data.producten.map(function (p) { return p.titel; }).join(', ') + '.'
          : '';
        el.sr.textContent = antwoord + kaartTekst;
      }
      klaarMetPraten();
      bewaar();
    }

    function aanFout(tekst) {
      if (typt.parentNode) typt.remove();
      toonFout(tekst || 'Er ging iets mis. Probeer het zo nog eens.');
      klaarMetPraten();
    }
  }

  function klaarMetPraten() {
    bezig = false;
    afbreker = null;
    el.stuur.disabled = false;
    scrollNaarBeneden(true);
  }

  /**
   * Leest een SSE-antwoord uit een fetch. EventSource kan geen POST, dus dit
   * moet met de hand. Het protocol is simpel: blokken gescheiden door een lege
   * regel, met "event:" en "data:" regels.
   */
  function leesStroom(respons, aanTekst, aanKlaar, aanFout) {
    var lezer = respons.body.getReader();
    var decoder = new TextDecoder();
    var buffer = '';
    var producten = [];
    var acties = [];

    function verwerkBlok(blok) {
      var naam = null, data = '';
      blok.split('\n').forEach(function (regel) {
        if (regel.indexOf('event:') === 0) naam = regel.slice(6).trim();
        else if (regel.indexOf('data:') === 0) data += regel.slice(5).trim();
      });
      if (!naam || !data) return;
      var payload;
      try { payload = JSON.parse(data); } catch (e) { return; }

      if (naam === 'tekst') aanTekst(payload.t);
      else if (naam === 'producten') producten = payload.items || [];
      else if (naam === 'acties') acties = payload.items || [];
      else if (naam === 'klaar') aanKlaar({
        tekst: payload.tekst,
        producten: producten.length ? producten : payload.producten,
        acties: acties.length ? acties : payload.acties,
        pose: payload.pose,
      });
      else if (naam === 'fout') aanFout((payload.fouten || [])[0]);
    }

    return lezer.read().then(function verder(res) {
      if (res.done) {
        if (buffer.trim()) verwerkBlok(buffer);
        return;
      }
      buffer += decoder.decode(res.value, { stream: true });
      var blokken = buffer.split('\n\n');
      buffer = blokken.pop();
      blokken.forEach(verwerkBlok);
      return lezer.read().then(verder);
    });
  }

  /* --------------------------------------------------------------- bewaren */

  function bewaar() {
    veiligOpslaan(OPSLAG, JSON.stringify({
      gesprekId: gesprekId,
      historie: historie.slice(-MAX_BEURTEN),
      pose: huidigePose,
    }));
  }

  /**
   * Een lopend gesprek terughalen na een paginawissel. Het paneel gaat NIET
   * vanzelf open — de bezoeker is ergens naartoe geklikt en wil dat zien.
   * Klikt hij de knop weer aan, dan staat het gesprek er nog.
   */
  function herstel() {
    var ruw = veiligLezen(OPSLAG);
    if (!ruw) return false;
    var data;
    try { data = JSON.parse(ruw); } catch (e) { return false; }
    if (!data || !data.historie || !data.historie.length) return false;
    gesprekId = data.gesprekId;
    historie = data.historie;
    return true;
  }

  /* ------------------------------------------------------------------ start */

  knop.addEventListener('click', openPaneel);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !paneel || paneel.hidden) return;
    // Loopt er een antwoord binnen, dan stopt de eerste Escape dát; pas de
    // tweede sluit het paneel. Scheelt per ongeluk weggegooide antwoorden.
    if (bezig && afbreker) { afbreker.abort(); afbreker = null; klaarMetPraten(); return; }
    sluitPaneel();
  });
  window.addEventListener('pagehide', function () { if (afbreker) afbreker.abort(); });

  var lopendGesprek = herstel();
  if (lopendGesprek) {
    // Alleen de tip onderdrukken; het paneel blijft dicht.
    verbergTip(false);
  } else {
    var tipGezien = false;
    try { tipGezien = !!localStorage.getItem(TIP_GEZIEN); } catch (e) {}
    if (!tipGezien) {
      setTimeout(function () {
        if (paneel && !paneel.hidden) return;
        var tip = document.createElement('div');
        tip.className = 'bkk-tip';
        tip.setAttribute('role', 'button');
        tip.tabIndex = 0;
        // Twee regels: de vraag, en eronder wat je eraan hebt. Alleen "hulp
        // nodig?" laat in het midden wat er dan gebeurt.
        var kop = document.createElement('strong');
        kop.className = 'bkk-tip__kop';
        kop.textContent = cfg.tipKop || 'Kan ik je helpen met je cadeau?';
        var sub = document.createElement('span');
        sub.className = 'bkk-tip__sub';
        sub.textContent = cfg.tipSub || 'Zeg voor wie het is, dan zoek ik iets uit.';
        tip.appendChild(kop);
        tip.appendChild(sub);
        var x = document.createElement('button');
        x.type = 'button'; x.className = 'bkk-tip__sluit';
        x.setAttribute('aria-label', 'Tip sluiten'); x.textContent = '×';
        x.addEventListener('click', function (e) { e.stopPropagation(); verbergTip(true); });
        tip.appendChild(x);
        tip.addEventListener('click', openPaneel);
        tip.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPaneel(); } });
        wortel.appendChild(tip);
      }, 8000);
    }
  }
})();
